<template>
  <Breadcrumb :items="breadcrumbs"/>
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <h4>جميع الطلاب ({{ paggination }})</h4>
      </div>
      <div class="row mb-3">
        <div class="col-lg-6 col-md-12 col-12">
          <div class="form-group">
            <label for="search">ابحث</label>
            <input type="search" id="search" class="form-control" placeholder="ابحث" v-model="word"
                   @keyup="debounceFetchReservation">
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label for="block">الصف</label>
            <Dropdown v-model="selected_level" :options="levels" showClear optionLabel="name" placeholder="اختر الصف"
                      class="w-100" @change="fetchReservation"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label for="block">حالة الطالب</label>
            <Dropdown v-model="block" :options="block_list" showClear optionLabel="title"
                      placeholder="حالة الطالب" @change="fetchReservation"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label for="gender">الجنس</label>
            <Dropdown v-model="gender" :options="gender_list" showClear optionLabel="title"
                      placeholder="الجنس" @change="fetchReservation"/>
          </div>
        </div>
    </div>
    <div class="row reservation-table reservation-table-three mb-3">
      <div id="reservationTable" class="a4">
        <div class="first-screen-pdf">
          <h1>كشوفات طلاب</h1>
          <h2>الصف الاول الثانوي</h2>
          <h3>{{ gender?.id === 1 ? "بنين" : gender?.id === 2 ? "بنات" : "" }} ( {{ paggination }} )</h3>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">رقم حجز الطالب</th>
              <th scope="col">
                <span @click="sortByName" class="d-flex align-items-center fw-bold gap-2 p-0 m-0" style="cursor: pointer">
                  الاسم
                  <i :class="sortAsc ? 'pi pi-sort-alpha-down' : 'pi pi-sort-alpha-up'"></i>
                </span>
              </th>
              <th scope="col">المرحلة التعليمية</th>
              <!-- <th scope="col">رقم الطالب</th> -->
              <th scope="col">رقم ولي الامر</th>
              <th scope="col">الجنس</th>
              <th scope="col">التعليم</th>
              <th scope="col">حالة الحجز</th>
              <th scope="col">التحكم</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reservation, index) in reservations.data" :key="index">
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="رقم حجز الطالب">{{ reservation.id }}</td>
              <td data-label="الاسم">{{ reservation.name }}</td>
              <td data-label="المرحلة التعليميه">{{ reservation.academic_year_name ?? '' }}</td>
              <!-- <td data-label="رقم الطالب">{{ reservation.student_phone }}</td> -->
              <td data-label="رقم ولي الامر">{{ reservation.parent_phone }}</td>
              <td data-label="الجنس">{{ reservation.gender == 1 ? "ولد" : "بنت" }}</td>
              <td data-label="التعليم">
                {{ reservation.education_type == 1 ? "عام" : reservation.education_type == 2 ? "أزهر" : "" }}
              </td>
              <td data-label="حالة الحجز">
                <template v-if="reservation.block === 0">
                  <span v-if="reservation.status == 0" class="status-badge status-badge--pending">الحجز معلق</span>
                  <span v-else-if="reservation.status == 1" class="status-badge status-badge--accepted">الحجز مقبول</span>
                  <span v-else-if="reservation.status == 2" class="status-badge status-badge--rejected">الحجز مرفوض</span>
                  <span v-else-if="reservation.status == 3" class="status-badge status-badge--waiting">في انتظار الشهادة</span>
                </template>
                <span v-else class="status-badge status-badge--blocked">محظور</span>
              </td>
              <td data-label="التحكم">
                <router-link class="btn btn-info text-white mx-1"
                             :tooltip="'تعديل كلمة المرور'"
                             flow="up"
                             :to="`/update_password/${reservation.user_id}`">
                  <i class="pi pi-unlock"></i>
                </router-link>
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل الحجز'"
                             flow="up"
                             :to="`/user/edit/${reservation.user_id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <router-link class="btn btn-secondary btn-sm mx-1" :to="`/user/edit/${reservation.user_id}#periodic-follow-ups`" aria-label="المتابعة الدورية للطالب"><i class="pi pi-list-check" aria-hidden="true"></i> المتابعة الدورية</router-link>
                <button :class="`btn ${reservation.block === 0 ? 'btn-danger': 'btn-success'} text-white mx-1`"
                        type="button"
                        :tooltip="`${reservation.block === 1 ? 'الغاء حظر الطالب' : 'حظر الطالب'}`"
                        flow="up"
                        @click="blockReservation(reservation.user_id)">
                  <i :class="`pi ${reservation.block === 0 ? 'pi-ban' : 'pi-circle'}`"></i>
                </button>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="'حذف الحجز'"
                        flow="up"
                        @click="deleteReservation(reservation.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
              <!-- certificate_image -->
            </tr>
            <!-- Add empty rows if needed -->
            <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
              <td>{{ reservations.data.length + n }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 col-12">
        <pagination :data="reservations"
                    class="mx-auto d-flex align-items-center justify-content-center pagination"
                    @pagination-change-page="fetchReservation">
          <template v-slot:prev-nav>&lt;</template>
          <template v-slot:next-nav>&gt;</template>
        </pagination>
      </div>
      <div class="col-md-2 col-12 mt-md-0 mt-3">
        <div class="form-group d-flex md-justify-content-end justify-content-center">
          <Dropdown v-model="per_page" :options="per_pages" showClear optionLabel="title"
                    placeholder="عدد الطلاب" @change="fetchReservation"/>
        </div>
      </div>
    </div>
  </div>
  </div>

  <Dialog v-model:visible="visible" :dismissableMask="true" modal header="صورة الشهادة">
    <img :src="certificate_image" class="certificate_image" alt="certificate_image">
  </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import pagination from "laravel-vue-pagination";
import * as XLSX from "xlsx/xlsx.mjs";
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BulkSms from "@/components/reservation/BulkSms.vue";
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "reservation-page",
  data() {
    return {
      reservations: {
        data: [],
      },
      certificate_image: "",
      visible: false,
      word: "",
      status: null,
      degree: "",
      gender: "",
      selected_level: null,
      status_list: [
        {
          id: 0,
          title: "معلق",
        },
        {
          id: 1,
          title: "مقبول",
        },
        {
          id: 2,
          title: "مرفوض",
        },
      ],
      gender_list: [
        {
          id: 1,
          title: "ولد",
        },
        {
          id: 2,
          title: "بنت",
        },
      ],
      per_pages: [
        {
          title: "الكل",
          id: 10000,
        },
        {
          title: 10,
          id: 10,
        },
        {
          title: 25,
          id: 25,
        },
        {
          title: 50,
          id: 50,
        },
        {
          title: 100,
          id: 100,
        },
      ],
      block_list: [
        {
          id: 0,
          title: "غير محظور",
        },
        {
          id: 1,
          title: "محظور",
        },
      ],
      block: null,
      per_page: null,
      paggination: "",
      sortAsc: true,
      orderByName: true,
      searchTimeout: null,
      breadcrumbs: [
        {name: 'الرئيسية', path: '/'},
        {name: 'جميع الطلاب', path: '/all_student'},
      ]
    }
  },
  components: {
    BulkSms,
    Dialog,
    Button,
    Dropdown,
    pagination,
    Breadcrumb
  },
  computed: {
    gradeStore() { return useGradeStore(); },
    levels() {
      const all = this.gradeStore.allGrades.length ? this.gradeStore.allGrades : this.gradeStore.activeGrades;
      return all.map(g => ({ name: g.name, id: g.id }));
    },
  },
  methods: {
    debounceFetchReservation() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchReservation();
      }, 1500); // يمكنك تغيير المدة حسب الحاجة
    },
    deleteReservation(reservation_id) {
      const formData = new FormData();
      formData.append('reservation_id', reservation_id);
      Swal.fire({
        title: "هل تريد حذف الحجز؟",
        text: "سيتم حذف الحجز نهائيا",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "حذف الحجز",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .post(`delete_reservation`, formData)
              .then(({data}) => {
                if (data.status == true) {
                  Swal.fire("", data.message, "success");
                  this.reservations.data = this.reservations.data.filter(r => r.id !== reservation_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },
    blockReservation(user_id) {
      const formData = new FormData();
      formData.append('user_id', user_id);
      Swal.fire({
        title: "هل تريد حظر الطالب؟",
        text: "سيتم حظر الطالب نهائيا",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "حظر الطالب",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .post(`toggle_block_user`, formData)
              .then(({data}) => {
                if (data.status == true) {
                  Swal.fire("", data.message, "success");

                  const reservation = this.reservations.data.find(r => r.user_id === user_id);
                  if (reservation) {
                    reservation.block = reservation.block === 0 ? 1 : 0;
                  }
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },
    fetchReservation(page = 1) {
      const formData = new FormData();
      if(this.selected_level) {
        formData.append('academic_year_id', this.selected_level.id);
      }

      if (this.block) {
        formData.append('is_block', this.block.id);
      }

      if (this.word) {
        formData.append('word', this.word);
      }
      if (this.status) {
        formData.append('status', this.status.id);
      }
      if (this.degree) {
        formData.append('degree', this.degree);
      }
      if (this.gender) {
        formData.append('gender', this.gender.id);
      }
      if (this.orderByName) {
        formData.append('order_by_name', this.orderByName ? 1 : 0);
      }

      axios.defaults.headers.common["per_page"] = this.per_page == null ? 10 : this.per_page.id;
      axios
          .post(`/all_reservations?page=${page}`, formData)
          .then((response) => {
            this.reservations = response.data.data;
            this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.reservations = {};
          });
    },
    sortByName() {
      this.orderByName = !this.orderByName;
      this.sortAsc = !this.sortAsc;
      //console.log(this.sortAsc, "sortAsc");
      //console.log(this.orderByName, "orderByName");
      this.fetchReservation()
    },
  },
  async mounted() {
    if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    this.fetchReservation();
  },
}
</script>

<style scoped>
@media print {
  th:nth-child(5),
  td:nth-child(5),
  th:nth-child(7),
  td:nth-child(7),
  th:nth-child(8),
  td:nth-child(8) {
    display: none !important;
  }
  th:nth-child(6),
  td:nth-child(6) {
    display: table-cell;
  }
}

.empty-row {
  display: none;
}

@media print {
  .empty-row {
    display: table-row !important;
  }
}
</style>